"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientSearchParameters = void 0;
exports.patientSearchParameters = {
    Account: ['subject'],
    AdverseEvent: ['subject'],
    AllergyIntolerance: ['patient', 'recorder', 'asserter'],
    Appointment: ['actor'],
    AppointmentResponse: ['actor'],
    AuditEvent: ['patient'],
    Basic: ['patient', 'author'],
    BodyStructure: ['patient'],
    CarePlan: ['patient', 'performer'],
    CareTeam: ['patient', 'participant'],
    ChargeItem: ['subject'],
    Claim: ['patient', 'payee'],
    ClaimResponse: ['patient'],
    ClinicalImpression: ['subject'],
    Communication: ['subject', 'sender', 'recipient'],
    CommunicationRequest: ['subject', 'sender', 'recipient', 'requester'],
    Composition: ['subject', 'author', 'attester'],
    Condition: ['patient', 'asserter'],
    Consent: ['patient'],
    Coverage: ['policy-holder', 'subscriber', 'beneficiary', 'payor'],
    CoverageEligibilityRequest: ['patient'],
    CoverageEligibilityResponse: ['patient'],
    DetectedIssue: ['patient'],
    DeviceRequest: ['subject', 'performer'],
    DeviceUseStatement: ['subject'],
    DiagnosticReport: ['subject'],
    DocumentManifest: ['subject', 'author', 'recipient'],
    DocumentReference: ['subject', 'author'],
    Encounter: ['patient'],
    EnrollmentRequest: ['subject'],
    EpisodeOfCare: ['patient'],
    ExplanationOfBenefit: ['patient', 'payee'],
    FamilyMemberHistory: ['patient'],
    Flag: ['patient'],
    Goal: ['patient'],
    Group: ['member'],
    ImagingStudy: ['patient'],
    Immunization: ['patient'],
    ImmunizationEvaluation: ['patient'],
    ImmunizationRecommendation: ['patient'],
    Invoice: ['subject', 'patient', 'recipient'],
    List: ['subject', 'source'],
    MeasureReport: ['patient'],
    Media: ['subject'],
    MedicationAdministration: ['patient', 'performer', 'subject'],
    MedicationDispense: ['subject', 'patient', 'receiver'],
    MedicationRequest: ['subject'],
    MedicationStatement: ['subject'],
    MolecularSequence: ['patient'],
    NutritionOrder: ['patient'],
    Observation: ['subject', 'performer'],
    Patient: ['link'],
    Person: ['patient'],
    Procedure: ['patient', 'performer'],
    Provenance: ['patient'],
    QuestionnaireResponse: ['subject', 'author'],
    RelatedPerson: ['patient'],
    RequestGroup: ['subject', 'participant'],
    ResearchSubject: ['individual'],
    RiskAssessment: ['subject'],
    Schedule: ['actor'],
    ServiceRequest: ['subject', 'performer'],
    Specimen: ['subject'],
    SupplyDelivery: ['patient'],
    SupplyRequest: ['subject'],
    VisionPrescription: ['patient']
};
